import React from 'react';
import ReactDOM from 'react-dom';
import CanvasEditor from './CanvasEditor'; 


ReactDOM.render(
  <React.StrictMode>
    <CanvasEditor />
  </React.StrictMode>,
  document.getElementById('root')
);